// extracted by mini-css-extract-plugin
export default {"popupBackground":"popup_popupBackground__0E+8h","popupContent":"popup_popupContent__KZWR3","crossIcon":"popup_crossIcon__W+1Fa"};